/**
 * Haptic Feedback Utility - Web Vibrations API
 * Provides native-like haptic feedback for premium touch interactions
 */

// Check if vibration API is supported
const isVibrationSupported = () => {
  return typeof navigator !== 'undefined' && 'vibrate' in navigator;
};

// Haptic patterns (duration in milliseconds)
export const HAPTIC_PATTERNS = {
  // Light tap - search bar focus, toggle activation
  light: 15,
  // Medium tap - booking tier selection
  medium: 25,
  // Strong tap - successful action
  strong: 40,
  // Double tap - confirmation
  double: [15, 50, 15],
  // Success pattern - booking complete
  success: [15, 30, 25, 30, 35],
  // Error pattern
  error: [50, 100, 50],
};

/**
 * Trigger haptic feedback
 * @param {string|number|number[]} pattern - Vibration pattern or preset name
 */
export const haptic = (pattern = 'light') => {
  if (!isVibrationSupported()) {
    return false;
  }

  try {
    // If it's a preset name, get the pattern
    const vibrationPattern = typeof pattern === 'string' 
      ? HAPTIC_PATTERNS[pattern] || HAPTIC_PATTERNS.light
      : pattern;

    navigator.vibrate(vibrationPattern);
    return true;
  } catch (error) {
    console.warn('[Haptic] Vibration failed:', error);
    return false;
  }
};

/**
 * Cancel any ongoing vibration
 */
export const cancelHaptic = () => {
  if (isVibrationSupported()) {
    navigator.vibrate(0);
  }
};

/**
 * React hook for haptic feedback
 */
export const useHaptic = () => {
  return {
    isSupported: isVibrationSupported(),
    trigger: haptic,
    cancel: cancelHaptic,
    patterns: HAPTIC_PATTERNS,
  };
};

export default haptic;
